// Types
import { DialogerStoreState } from './useDialogerStore.types';

/**
 * Represents an initial state for the Dialoger.
 */
export const initialState: DialogerStoreState = {
  isOpen: false,
  dialogerSetup: {
    header: <></>,
    body: <></>,
  },
};
